import React from 'react';
import styles from './AvgAreaSessionsWidget.module.scss';
import api from 'helpers/api';

import moment from 'moment';
import Tooltip from 'components/miscellaneous/Tooltip/Tooltip';

import {FiInfo} from 'react-icons/fi';
import Loader from 'components/miscellaneous/Loader/Loader';
import {$t} from 'helpers/translator';

class AvgAreaSessionsWidget extends React.Component {
    constructor(props) {
        super(props);
        const { startDate, endDate } = props.dateRange;

        this.state = {
            data: null,
            startDate: moment().subtract(1, 'years').format('YYYY-MM-DD'),
            endDate: moment().format('YYYY-MM-DD'),

            startDateInitialProp: startDate,
            endDateInitialProp: endDate,
            updated: false,

            loading: true,
        };
    }

    async componentDidMount() {
        await this.init();
    }

    /**
     * triggers when component (or props) changes
     * checks for prop change of dates and renders component again
     */
    componentDidUpdate(prevProps, prevState, snapshot) {
        let newState = {
            data: null,
            startDate: moment(this.props.startDate).format('YYYY-MM-DD'),
            endDate: moment(this.props.endDate).format('YYYY-MM-DD'),
        };

        //First time a different date range is passed via props, setting update to true
        if (!this.state.updated && (newState.startDate !== this.state.startDateInitialProp || newState.endDate !== this.state.endDateInitialProp)) {
            this.setState({updated: true});
        }
        //If props weren't changed since component was mounted, the component will not be re rendered
        if (!this.state.updated) {
            return;
        }

        if (newState.startDate !== this.state.startDate || newState.endDate !== this.state.endDate) {
            this.setState(newState, async () => {
                await this.init();
            });
        }
    }

    async init() {
        this.setState({loading: true}, async () => {
            try {
                let res = await api.get(`dashboard/treatments/avgperarea?startDate=${this.state.startDate}&endDate=${this.state.endDate}`);
                // console.log('dashboard/treatments/avgperarea', res)
                this.setState({data: res.data.data, loading: false}, () => {
                    // console.log('AST state>> new state after fetch', this.state)
                });
            } catch (e) {
                console.error('err fetching');
                this.setState({loading: false})
            }
        })
    }

    render() {
        const toolTipText = $t('global.averageSessionsForTreatment.info');

        return (
            <div className={styles.container}>
                <div>
                    {this.state.loading ?
                        <Loader color="#ddd" />
                        :
                        <div>

                            {this.state.data ?
                                <div className={`${styles['treatments-container']} `}>
                                    {!this.state.data.length &&
                                        <div className={`${styles['loader-container']} `} style={{padding: '10px'}}>
                                            {$t('global.general.noDataFound')}
                                        </div>
                                    }
                                    {this.state.data.filter(t => t.name !== null).map((treatment, k) => {
                                        if(k < 16) {
                                            return (
                                                <Tooltip
                                                    key={k}
                                                    content={$t('global.general.patients') + ': ' + treatment.count_patients + ' | ' + $t('global.general.treatments') + ': ' + treatment.count_sessions}>
                                                    <div className={`${styles['treatment-container']} `}>

                                                        <div className={`${styles['treatment-top-container']} `}>
                                                            <div className={`${styles['image-container']} `}
                                                                alt={$t('global.areas.' + treatment.name)}
                                                                style={{
                                                                    background: 'url(\'' + treatment.image + '\')  50% 0% no-repeat',
                                                                    backgroundSize: 'cover',
                                                                    position: 'relative'
                                                                }}>

                                                                <div className={`${styles['circle-text-overlay']} `}>
                                                                    {treatment['treatments_avg']}
                                                                </div>
                                                            </div>
                                                        </div>
                                                        <div className={`${styles['area-name']} `}>
                                                            {$t('global.areas.' + treatment.name)}
                                                        </div>
                                                    </div>
                                                </Tooltip>
                                            )
                                        }
                                    })}
                                </div>
                                :
                                <div className={`${styles['treatments-container']} `}>
                                    {$t('global.general.noDataFound')}
                                </div>
                            }
                        </div>
                    }
                </div>
            </div>
        );
    }
}

export default AvgAreaSessionsWidget;
